import { render, staticRenderFns } from "./preScreeningEntryListEnd.vue?vue&type=template&id=522871b8&scoped=true&"
import script from "./preScreeningEntryListEnd.vue?vue&type=script&lang=js&"
export * from "./preScreeningEntryListEnd.vue?vue&type=script&lang=js&"
import style0 from "./preScreeningEntryListEnd.vue?vue&type=style&index=0&id=522871b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522871b8",
  null
  
)

export default component.exports